import React from 'react';

import { useAppContext } from '@prisjakt/ui-app-context';
import { usePriceRowContext } from 'src/areas/product/components/price-list/price-row-context';

import {
  CaptionText,
  FontColor,
  FontEmphasis,
} from '@prisjakt/ui/text/variants';
import { MediumUp } from 'src/ui/block';
import { ShippingLabel } from '../shipping/shipping-label';
import { getCompiledPriceData } from '../offer-price-experiment/price-data';

import { PriceDisplay } from 'src/components/price-list/types';
import { PricePrice, CampaignMediaColors, Maybe, OfferPrices } from 'src/types';

import {
  PriceAndShipping,
  StyledBadge,
  StyledPriceLabel,
  StyledSecondaryPrice,
  Wrapper,
} from './styles';

interface IPriceLabel {
  price?: PricePrice | null;
  offerPrice?: OfferPrices | null;
  priceDisplay: PriceDisplay;
  campaignColors?: Maybe<CampaignMediaColors>;
}

export const OfferPriceLabel: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceLabel>
>> = props => {
  const { price, offerPrice, campaignColors, priceDisplay } = props;

  const { t, market } = useAppContext();
  const { isFeatured = false, forceMobileView } = usePriceRowContext();

  if (!price) {
    return null;
  }

  const priceData = getCompiledPriceData(
    price,
    offerPrice,
    priceDisplay,
    isFeatured,
    t,
    market
  );

  return (
    <Wrapper>
      {priceData.label && (
        <>
          {priceData.isMemberPrice ? (
            <StyledBadge color="GREY_INVERTED" text={priceData.label} />
          ) : (
            <CaptionText emphasis={FontEmphasis.MEDIUM}>
              {priceData.label}
            </CaptionText>
          )}
        </>
      )}

      <PriceAndShipping>
        {price && isFeatured && !forceMobileView && (
          <MediumUp>
            <ShippingLabel price={price} priceDisplay={priceDisplay} />
          </MediumUp>
        )}

        {priceData.secondaryPrice && (
          <StyledSecondaryPrice
            value={priceData.secondaryPrice}
            emphasis={FontEmphasis.LOW}
          />
        )}

        {priceData.mainPrice && (
          <StyledPriceLabel
            value={priceData.mainPrice}
            emphasis={isFeatured ? FontEmphasis.HIGH : FontEmphasis.LOW}
            fontColor={campaignColors ? FontColor.NEGATIVE : undefined}
          />
        )}
      </PriceAndShipping>
    </Wrapper>
  );
};
